module.exports = __webpack_public_path__ + "static/media/collaborationEU-ES.2b5c24b3.png";